import React, { Component } from 'react';
import { connect } from 'react-redux';
import { WithTranslation, withTranslation } from 'react-i18next';
import { Dispatch } from 'redux';
import { bluetoothConnection, handleActivityStatus, handleBluetoothState } from '../../actions/bluetooth.actions';
import BluetoothWrapper from '../../utils/BluetoothWrapper';

interface BluetoothProps extends WithTranslation{
    dispatch: Dispatch<any>,
    callback: any,
    activityStatus:string,
    bluetoothStatus: string,
    bluetoothConnected: boolean,
    calibrationStatus: string,
}

interface BluetoothComponentState{
    requestConnection: boolean,
}

class Bluetooth extends Component<BluetoothProps, BluetoothComponentState> {
    private bluetoothWrapper: BluetoothWrapper;

    constructor(props: BluetoothProps) {
        super(props);
        this.state = {
            requestConnection: false,
        };
        this.bluetoothWrapper = new BluetoothWrapper("android");
    }

    componentDidMount() {
        this.bluetoothWrapper.init().then(()=>{
            if(!this.bluetoothWrapper.connected && this.props.bluetoothConnected){
                this.props.dispatch(bluetoothConnection(false));
            }
            if(this.bluetoothWrapper.connected){
                this.props.dispatch(handleActivityStatus("calibrate"));
                this.props.dispatch(handleBluetoothState('on'));
                this.props.dispatch(bluetoothConnection(true));
            }
        });
    }

    componentDidUpdate(prevProps: BluetoothProps) {
        if (this.props.bluetoothStatus !== prevProps.bluetoothStatus) {
            if (this.props.bluetoothStatus === 'off' && this.bluetoothWrapper.connected) {
                this.bluetoothWrapper.disconnect();
            }
        }
    }

    componentWillUnmount() {
        if (this.bluetoothWrapper.connected) {
            this.bluetoothWrapper.disconnect();
        }
    }

    connect = () => {
        if (this.state.requestConnection) {
            return;
        }
        this.setState({ requestConnection: true });
        this.bluetoothWrapper.connect().then(()=>{
            this.props.dispatch(bluetoothConnection(true));
            this.props.dispatch(handleActivityStatus("calibrate"));
            this.props.dispatch(handleBluetoothState('on'));
        }).catch((error)=>{
            this.setState({ requestConnection: false });
            console.error('Bluetooth connection failed:', error);
        });
    }

    disconnect = () => {
        this.bluetoothWrapper.disconnect();
        this.props.dispatch(bluetoothConnection(false));
        this.props.dispatch(handleBluetoothState('off'));
    }

    render() {
        const { t } = this.props;
        const { bluetoothStatus, bluetoothConnected } = this.props;
        const { requestConnection } = this.state;

        return (
            <div className="bluetooth-container">
                <div className="bluetooth-status">
                    <span className={`status-indicator ${bluetoothStatus}`}>
                        {bluetoothStatus === 'on' ? '●' : '○'}
                    </span>
                    <span className="status-text">
                        {bluetoothStatus === 'on' ? t('bluetooth.connected') : t('bluetooth.disconnected')}
                    </span>
                </div>
                
                <div className="bluetooth-controls">
                    {!bluetoothConnected ? (
                        <button 
                            className="connect-btn"
                            onClick={this.connect}
                            disabled={requestConnection}
                        >
                            {requestConnection ? t('bluetooth.connecting') : t('bluetooth.connect')}
                        </button>
                    ) : (
                        <button 
                            className="disconnect-btn"
                            onClick={this.disconnect}
                        >
                            {t('bluetooth.disconnect')}
                        </button>
                    )}
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state: any) => ({
    bluetoothStatus: state.bluetooth.status,
    bluetoothConnected: state.bluetooth.connected,
    activityStatus: state.bluetooth.activityStatus,
    calibrationStatus: state.bluetooth.calibrationStatus,
});

export default withTranslation('workout')(connect(mapStateToProps)(Bluetooth))

